"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSubscriptionBeExtended = void 0;
/**
 * Decides if a subscription can be extended or not.
 * Given that In-App subscriptions are out of our control,
 * only the Chargebee ones can be extended.
 */
const canSubscriptionBeExtended = (subscription) => subscription.plan.provider === "chargebee";
exports.canSubscriptionBeExtended = canSubscriptionBeExtended;
//# sourceMappingURL=subscription_utils.js.map